import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

//! Router의 Link로 구현할 수 있어야됨
export default function Data({ children }: Props) {
  return (
    <td className="typo-body2 border-gray-5 h-[55px] border-l-[1px] border-t-[1px] text-center text-[#3d3d3d] [&>*]:mx-auto">
      {children}
    </td>
  )
}
